var _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconStatus = function SvgIconStatus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "iconStatus",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.17323 17.00787"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "thinStroke",
    cx: 7.08661,
    cy: 8.50451,
    r: 1.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "thickStroke",
    cx: 7.08661,
    cy: 8.50394,
    r: 5.21717
  })));
};
export default SvgIconStatus;